import { render, staticRenderFns } from "./ProductTechnicalInfo.vue?vue&type=template&id=23821f47&"
import script from "./ProductTechnicalInfo.vue?vue&type=script&lang=js&"
export * from "./ProductTechnicalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports